module.exports = __webpack_public_path__ + "static/media/Search.cf2353c3.svg";